<template>
  <div class="form-fw__header" :class="{ 'form-fw__header--shadow': shadow }">
    <header>
      <v-layout align-center justify-start row>
        <v-flex xs2 md3>
          <v-btn class="mx-0" flat icon @click="prevPage">
            <v-icon color="gray-6">arrow_back</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs8 md6>
          <div class="text-xs-center">
            <h1 class="form-fw__header__title">{{ title }}</h1>
          </div>
        </v-flex>

        <v-flex xs2 md3 v-if="pageType === 'list'">
          <div class="text-xs-right pr-2 hidden-xs-only hidden-sm-only">
            <strong>{{ $t(`${namespace}.newReportText`) }}</strong>
            <br />
            <span>
              <a
                href="#"
                :title="$t(`${namespace}.newReportLink`)"
                class="accent--text"
                @click.prevent="exportNewReport"
              >{{ $t(`${namespace}.newReportLink`) }}</a>
            </span>
          </div>
        </v-flex>
      </v-layout>
    </header>

    <transition name="fade">
      <v-progress-linear
        v-if="status === isLoading"
        color="accent"
        class="pa-0 ma-0"
        height="3"
        indeterminate
      />
    </transition>
  </div>
</template>

<script>
import {
  STATUS_IS_LOADING,
  STATUS_SUCCESS,
  STATUS_FAILED
} from 'utils/constants'
import { goBack } from 'utils/functions'

export default {
  name: 'ConsolidatedReportHeader',
  props: {
    status: {
      type: Number
    },
    pageType: {
      type: String,
      default: 'list'
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED,
    title () {
      return this.pageType === 'list'
        ? this.$t(`${this.namespace}.listReportTitle`)
        : this.$t(`${this.namespace}.newReportTitle`)
    }
  },
  data () {
    return {
      namespace: 'Views.ConsolidatedReportsPage',
      shadow: false
    }
  },
  methods: {
    prevPage () {
      this.pageType === 'list'
        ? this.$router.push({ name: 'Reports' })
        : goBack()
    },

    exportNewReport () {
      this.$emit('exportNewReport')
    },

    handleShadow () {
      this.shadow = window.scrollY > 0
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
